import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import ReactTable from 'react-table';
import TableWrapper from "./ReactTableWrapper";
export { default as PaginationComponent } from "./PaginationComponent";
export { default as LoadingComponent } from "./LoadingComponent";
export { default as selectTableHOC } from "./selectTableHOC";

// eslint-disable-next-line react/display-name
var Table = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TableWrapper, null, /*#__PURE__*/React.createElement(ReactTable, _extends({}, props, {
    ref: ref
  })));
});
export default Table;